import { expertise } from '@/mocks/home';
import SmartLink from '@/components/feature/SmartLink';

export default function Expertise() {
  return (
    <section id="expertise" className="bg-background-100 sec">
      <div className="wrap">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12 md:mb-20" data-reveal>
          <h2 className="h-sec text-foreground-950">Where we make<br />a difference.</h2>
          <span className="label-xs text-foreground-600">Expertise</span>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-14">
          {expertise.map((e) => (
            <div key={e.no} data-reveal>
            <SmartLink href="#contact" className="group flex flex-col cursor-pointer">
              <div data-clip className="w-full aspect-[4/3] overflow-hidden">
                <img src={e.img} alt={`${e.title} — AUREN consulting`} title={`${e.title} consulting`} className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-[1.03]" />
              </div>
              <span className="label-xs text-foreground-600 mt-4">{e.no} / {e.tag}</span>
              <h3 className="h-card text-foreground-950 mt-2.5 min-h-[2.4em]">{e.title}</h3>
              <div className="flex items-start justify-between gap-6 mt-3">
                <p className="text-[15px] leading-[1.6] text-foreground-700 max-w-[340px]">{e.text}</p>
                <span className="circle-arrow inv-dark text-foreground-950" aria-hidden="true"><i className="ri-arrow-right-line" /></span>
              </div>
            </SmartLink>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}